module.exports = __webpack_public_path__ + "static/media/hualian_pic6.c891bdd4.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic6.jpg
 ** module id = 449
 ** module chunks = 0
 **/